import { create } from "zustand";
import { CommonResponseModel, configuredWebhookData, WebhookExternalConfig } from "../models/axiosModel";
import agent from "../services/api";

interface useWebhookStoreInterface {
    configuredWebhookData: configuredWebhookData[] | null, 
    setConfiguredWebhookData: (value: any) => void,
    getWebhookOrganizationList: () => Promise<CommonResponseModel<configuredWebhookData>>,

    webhookExternalData: WebhookExternalConfig[] | null,
    setWebhookExternalData: (value: WebhookExternalConfig[] | null) => void,
    getWebhookExternalDataApi: () => Promise<CommonResponseModel<WebhookExternalConfig>>,
}

export const useWebhookStore = create<useWebhookStoreInterface>((set) => ({
    configuredWebhookData: null,  
    setConfiguredWebhookData: (value: any) => set({ configuredWebhookData: value }), 
    getWebhookOrganizationList: async () => {
        const res = await agent.getWebhookOrganizationList.get();
        if(res.status){
            set({ configuredWebhookData: res.data });
        } else {
            set({ configuredWebhookData: null });
        } 
        return res;
    },

    webhookExternalData: null, 
    setWebhookExternalData: (value: WebhookExternalConfig[] | null) => set({ webhookExternalData: value }),
    getWebhookExternalDataApi: async () => {
        const res = await agent.getWebhookExternal.get(); 
        if(res.status){
            set({ webhookExternalData: res.data })
        } else {
            set({ webhookExternalData: null })
        } 
        return res;
    }
}))